// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { titleTypographyStyles } from "@conklin/App/Components/TitleTypography/TitleTypography";
import IconArrowRight from "@conklin/XDL/Icons/IconArrowRight";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { linkArrowStyle, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

titleTypographyStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-end;
        flex-wrap: wrap;
        width: 100%;
        ${xScreen("lte", "sm")} {
            flex-direction: column;
            align-items: flex-start;
        }
    `,
};

titleTypographyStyles.title = {
    variant: "h3",
    color: "text.main",
    css: css`
        margin-right: auto;
        margin-bottom: 0;
    `,
};

titleTypographyStyles.link = {
    typographyProps: {
        size: fontConfig.fontSize.small,
        lineHeight: fontConfig.lineHeight.small,
        weight: fontConfig.weight.bold,
        css: css`
            letter-spacing: 0;
        `,
    },
};

titleTypographyStyles.linkWithArrow = {
    ...linkArrowStyle("small", {
        css: css`
            align-self: flex-end;
        `,
    }),
};
